import React from "react";
import PropTypes from "prop-types";

import { customStyles } from "../../styles/tableStyle";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Disclaimer from "../other/Disclaimer";
import PolicyReminder from "../other/PolicyReminder";
import { appMessages } from "../../constants/appMessages";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
const { Card, CardContent, CardActions, Button, LinearProgress,
  Typography, Box, FormControl, List, ListItem, ListItemIcon, ListItemText } = require("@mui/material")

const { commons, util } = require("../../commons")
const { SnackBarWidget, DialogWidget } = require("../../Widget");


class Connection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      message: "",
      apiService: false,
      selectedFile: false,
      uploadErr: "",
      inputKey: 0,
      showDialog: false,
      action: "",
      verilogType: 'sv',
      policyDialog: false
    };
  }

  componentDidMount() {
  }



  resetForm = async () => {
    this.setState({ selectedFile: false, uploadErr: "", inputKey: 0 })
  };

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  openDialog = () => {
    let { showDialog } = this.state;
    this.setState({ showDialog: true });
  };

  loadDefaults = () => {
    this.setState({ status: false, message: "" })
  }

  handleRadioChange = (event) => {
    this.setState({ verilogType: event.target.value })
  };

  uploadFile = async (e) => {
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    let uploadedFile = e.target.files[0];
    if (!uploadedFile) {
      this.setState({ uploadErr: 'Please upload file.' });
    }
    else if (uploadedFile && !validTypes.includes(uploadedFile.type)) {
      this.setState({ uploadErr: 'Please upload valid file.' });
    }
    else if (uploadedFile && uploadedFile.type === "") {
      this.setState({ uploadErr: 'Please upload valid file.' });
    }
    else this.setState({ selectedFile: uploadedFile, uploadErr: "", inputKey: 1 })

  }

  validateFile = (e, action) => {
    let { selectedFile } = this.state;
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    this.setState({ uploadErr: "", projectError: false, showDialog: false, policyDialog: false })
    let projectId = localStorage.getItem("projectId")
    if (projectId == '') {
      this.setState({ projectError: true })
      return;
    }
    if (!selectedFile) {
      this.setState({ uploadErr: 'Please upload file.' });
      return;
    }


    if (selectedFile && !validTypes.includes(selectedFile.type)) {
      this.setState({ uploadErr: 'Please upload valid file.' });
      return;
    }
    this.setState({ action: action })
    if (action == "check") this.setState({ policyDialog: true })
    this.openDialog();

  }

  displayPolicyDialog = () => {
    this.setState({ policyDialog: true })
    this.openDialog()
  }

  handleConnectionFile = () => {
    this.closeDialog()
    let { selectedFile, action, verilogType } = this.state;
    let projectId = localStorage.getItem("projectId")
    this.setState({ apiService: true })
    let data = new FormData();
    data.append('projectId', projectId);
    data.append('file', selectedFile);
    data.append('type', this.props.type.toLowerCase())
    let op = action == "check" ? 'checkConnection' : 'uploadConnection'
    data.append('op', op)
    if( op == "uploadConnection")
      data.append('verilogType', verilogType)
    try {
      commons.getAPIRes(data, "POSTFORMDATA", "rtltop").then(res => {
        this.setState({ apiService: false })
        if (res.logs)
          localStorage.setItem("newLogs", res.logs)
        this.props.loadLogs()

        if (!res.status) {
          this.setState({ message: this.props.type + appMessages.uploadFailMsg, status: false })
          setTimeout(function () {
            this.loadDefaults()
          }.bind(this), 2000)
        }
        if (res.status) {
          this.setState({ message: res.message ? res.message : this.props.type + appMessages.uploadSucMsg, status: true })
          const zipContent = atob(res.result);
          const zipBlob = new Blob([Uint8Array.from(zipContent, c => c.charCodeAt(0))], { type: 'application/zip' });
          const url = window.URL.createObjectURL(zipBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'files.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

      });
    } catch (error) {
      console.error('There was an error downloading the zip file!', error);
    }
  }
  checkFile = async (e, action) => {
    let { selectedFile } = this.state;
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    this.setState({ uploadErr: "", projectError: false, showDialog: false })
    let projectId = localStorage.getItem("projectId")
    if (projectId == '') {
      this.setState({ projectError: true })
      return;
    }
    if (!selectedFile) {
      this.setState({ uploadErr: 'Please upload file.' });
      return;
    }

    if (selectedFile && !validTypes.includes(selectedFile.type)) {
      this.setState({ uploadErr: 'Please upload valid file.' });
      return;
    }
    this.setState({ action: action })
  };



  render() {
    const { status, message, apiService, uploadErr, selectedFile, showDialog, action, verilogType, policyDialog } = this.state;

    return (
      <Box sx={{ alignContent: 'center' }}>
        <Card style={{ margin: "10px" }} variant="outlined" sx={{
          bgcolor: 'background.paper',
          border: "none", boxShadow: "none",

          p: 2,
          minWidth: 300,
          // minHeight: 450
        }}>

          <CardContent>
            {apiService ? <LinearProgress /> : false}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="caption">Upload Connection File &nbsp;</Typography>
              <FormControl fullWidth style={{ flex: 2 }}>
                <input
                  multiple
                  type="file"
                  name="myImage"
                  onChange={(e) => this.uploadFile(e)}
                /> </FormControl>
            </div>


            <br />

            {uploadErr.length ? <Typography color="error" variant="subtitle">

              {uploadErr}
            </Typography> : false}
          </CardContent>

          <CardActions style={{ justifyContent: "flex-end" }} >

            <Button variant="contained" color="primary"
              style={customStyles.successBtn}
              size="small" onClick={e => this.validateFile(e, "check")}
            >
              Check
            </Button>
            <Button variant="contained" color="primary"
              style={customStyles.successBtn}
              size="small" onClick={e => this.validateFile(e, "upload")}
            >
              Download
            </Button>
          </CardActions>
          <br />
          <Disclaimer style={{ marginTop: 10 }} />
        </Card>
        {showDialog && action == "upload" ? (
          <DialogWidget
            maxWidth={"md"}
            dialogTitle={"Verilog Type"}
            dialogContent={
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={verilogType}
                name="radio-buttons-group"
                style={{ flexDirection: 'row' }}
                onChange={(e) => this.handleRadioChange(e)}
              >
                <FormControlLabel value={"sv"} control={<Radio />} label="System Verilog" />
                <FormControlLabel value={"v"} control={<Radio />} label="Verilog" />
              </RadioGroup>
            }
            okDialog={this.displayPolicyDialog}
            closeDialog={this.closeDialog}
            okTitle={"Continue"}
            negCancel={true}

          />
        ) : (
          false
        )}
        {showDialog && policyDialog ? (

          <DialogWidget
            maxWidth={"md"}
            dialogTitle={"Reminder"}
            dialogContent={
              <PolicyReminder

              />
            }
            okDialog={this.handleConnectionFile}
            closeDialog={this.closeDialog}
            okTitle={"Continue"}
            negCancel={true}

          />
        ) : (
          false
        )}
        <SnackBarWidget message={message} status={status} />
      </Box>
    );
  }
}

Connection.propTypes = {
  id: PropTypes.string,
  cancelDialog: PropTypes.func,
  reloadPage: PropTypes.func,
  action: PropTypes.string
};
export default Connection;
